import './item.css';

import { Link } from 'react-router-dom';
import React, { useContext } from 'react';
// import { CartContext } from '../../context/CartContext';

const Hw3Item = ({ info }) => {
    // const nombre =useContext(CartContext);

    return (
      // <Link to={`/detalle/${info.id}`} className="imagen">
            <Link to={`/detalle/${info.id}`}>
              <div style={{
                padding: "2px 4px 2px",
                // height: 60,
              backgroundColor: "#b7e780",
              color: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "left",
              fontWeight: "bold",
              }}>
                            {/* <button onClick={updateSort2}>Sort2</button> */}
            <button>Delete</button>

              {info.title}
              </div>
           
            <img src={info.image} alt="" className="imagen"/>
            </Link>
    );
}

export default Hw3Item;